import React from "react";
import { type TemplateFormGroup } from "../model";
import TemplateEditItem from "./TemplateEditItem";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  group: TemplateFormGroup
  onChange: (advancingChunkId: string, behavior: server.dto.FormElementBehaviors) => void
  onSectionTypeChange: (group: TemplateFormGroup, behavior: server.dto.FormElementBehaviors) => void
}

export default class TemplateEditSection extends React.Component<Props> {
  onCheck = (checkedValue: server.dto.FormElementBehaviors) => {
    this.props.onSectionTypeChange(this.props.group, checkedValue);
  };

  public render(): JSX.Element {
    const { group } = this.props;
    const rows = group.rows;

    const allRowsOfType = rows.length > 0 && rows.every(row => row.formElementBehavior === rows[0].formElementBehavior)
      ? rows[0].formElementBehavior
      : undefined;

    return <>
      <h2 className="advancing-template-header-row">{group.label}</h2>
      <RadioGroup<server.dto.FormElementBehaviors>
        wrapperClassName="advancing-template-header-row-radio"
        orientation="horizontal"
        options={[{
          label: RESX.Advancing.Hidden,
          value: "notVisible"
        }, {
          label: RESX.Advancing.ReadOnly,
          value: "disabled"
        }, {
          label: RESX.Advancing.Optional,
          value: "visibleOptional"
        }, {
          label: RESX.Advancing.Required,
          value: "visibleMandatory"
        }]}
        value={allRowsOfType}
        onChange={value => this.onCheck(value)}
      />
      {
        rows.map(row => (
          <TemplateEditItem key={row.advancingChunkId} row={row} onChange={this.props.onChange} />
        ))
      }
    </>;
  }
}
